<template>
    <button class="button is-primary is-fullwidth" @click="search()" :class="{ 'is-loading' : isLoading }">SEARCH</button>
</template>

<script>

export default {
   methods: {
       search() {
           this.$store.dispatch('fetchProfitSectionInvoicesWithQuery');
       }
   },
   computed: {
       isLoading() {
           return this.$store.getters.getProfitSectionData.is_loading
       }
   },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitSearchButton.vue